/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateCheckoutRedelivery201ResponseAllOfData } from './CreateCheckoutRedelivery201ResponseAllOfData';
import {
    CreateCheckoutRedelivery201ResponseAllOfDataFromJSON,
    CreateCheckoutRedelivery201ResponseAllOfDataFromJSONTyped,
    CreateCheckoutRedelivery201ResponseAllOfDataToJSON,
} from './CreateCheckoutRedelivery201ResponseAllOfData';

/**
 * 
 * @export
 * @interface CreateCheckoutRedelivery201ResponseAllOf
 */
export interface CreateCheckoutRedelivery201ResponseAllOf {
    /**
     * 
     * @type {CreateCheckoutRedelivery201ResponseAllOfData}
     * @memberof CreateCheckoutRedelivery201ResponseAllOf
     */
    data: CreateCheckoutRedelivery201ResponseAllOfData;
}

/**
 * Check if a given object implements the CreateCheckoutRedelivery201ResponseAllOf interface.
 */
export function instanceOfCreateCheckoutRedelivery201ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function CreateCheckoutRedelivery201ResponseAllOfFromJSON(json: any): CreateCheckoutRedelivery201ResponseAllOf {
    return CreateCheckoutRedelivery201ResponseAllOfFromJSONTyped(json, false);
}

export function CreateCheckoutRedelivery201ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCheckoutRedelivery201ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': CreateCheckoutRedelivery201ResponseAllOfDataFromJSON(json['data']),
    };
}

export function CreateCheckoutRedelivery201ResponseAllOfToJSON(value?: CreateCheckoutRedelivery201ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CreateCheckoutRedelivery201ResponseAllOfDataToJSON(value.data),
    };
}

